import React, { useEffect, useState } from 'react';
import { FaSync, FaTimes, FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { FaCookieBite } from 'react-icons/fa6';
import cookiesGif from '../../assets/gifs/Cookies.gif';
import { Button } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next";

function CookiesPopup() {
    const [t] = useTranslation("cookies")
    const [isVisible, setIsVisible] = useState(false);
    const [isConfig, setIsConfig] = useState(false);
    const [customizationCookies, setCustomizationCookies] = useState(Cookies.get('myreportin_cookies_enabled'));


    const handleAccept = () => {
        setIsVisible(false);
        Cookies.set('myreportin_cookies_enabled', true, { expires: 730, secure: true, sameSite: 'none' });
        setCustomizationCookies(true)
    };

    const handleReject = () => {
        setIsVisible(false);
        Cookies.set('myreportin_cookies_enabled', false, { expires: 730, secure: true, sameSite: 'none' });
        setCustomizationCookies(false)
    };

    const handleConfig = () => {
        setIsConfig(!isConfig);
    };

    const handleClose = () => {
        setIsVisible(false);
        sessionStorage.setItem('cookiespopuphide', true)
    };

    const handleOpen = () => {
        setIsVisible(true);
        setIsConfig(true)
    };

    function openCookies() {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);

        return () => clearTimeout(timer);
    }

    useEffect(() => {
        const cookiesPopupHide = sessionStorage.getItem('cookiespopuphide');



        if (!cookiesPopupHide && customizationCookies === undefined) {

            openCookies()
        }
    }, []);


    return (

        <>
            <div onClick={handleOpen} className={`cookies-config-button ${isVisible ? 'cookies-container-hidden' : ''}`}>
                <FaCookieBite className='cookies-config-button-img' />
            </div>
            <div className={`cookies-container ${!isVisible && 'cookies-container-hidden'}`}>
                <div className='cookies-card rounded-border-px custom-shadow-bold'>
                    <img
                        src={cookiesGif}
                        alt="Cookies GIF"
                        className='cookies-gif'
                    />
                    <Button
                        variant="none"
                        className="modal-close-button"
                        onClick={handleClose}
                    >
                        <FaTimes />
                    </Button>

                    {isConfig ?

                        <div className='cookies-config-container'>
                            <div className='cookies-config-scroll'>
                                <details className='cookies-config-details-container custom-shadow-bold'>
                                    <summary className='cookies-config-details-title'>{t("cookiesPopup.essentialCookies")}<span className='cookies-always-active'>{t("cookiesPopup.alwaysEnabled")}</span></summary>
                                    <p className='p-2'>{t("cookiesPopup.essentialCookiesText")}</p>
                                </details>
                                <details className='cookies-config-details-container custom-shadow-bold'>
                                    <summary className='cookies-config-details-title'>{t("cookiesPopup.customizationCookies")}<span className='cookies-always-active'>{customizationCookies ? `${t("cookiesPopup.enabled")}` : `${t("cookiesPopup.disabled")}`} </span></summary>
                                    <p className='p-2'>{t("cookiesPopup.customizationCookiesText")}</p>
                                </details>
                            </div>
                        </div>
                        :
                        <>
                            <h3>{t("cookiesPopup.title")}</h3>
                            <p className='cookies-text'>
                                <>
                                    {t("cookiesPopup.text1")}{' '}
                                    <a href='https://www.linksoluciones.com/politica-de-cookies/' target='_blank' rel='noopener noreferrer'>
                                        {t("cookiesPopup.text2")}
                                    </a>
                                    <br /> {t("cookiesPopup.text3")}
                                </>
                            </p>
                        </>
                    }

                    <div className='d-flex flex-row justify-content-evenly w-100 mb-2'>
                        <div className='cookies-accept custom-shadow-bold ' onClick={handleConfig}>
                            {t("cookiesPopup.configure")}
                        </div>
                        <div className='cookies-accept custom-shadow-bold ' onClick={handleReject}>
                            {t("cookiesPopup.deny")}
                        </div>
                        <div className='cookies-accept custom-shadow-bold ' onClick={handleAccept}>
                            {t("cookiesPopup.accept")}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )

}

export default CookiesPopup;
